export default "__VITE_ASSET__D8I_JZRg__"